import { combineEpics, type Epic, ofType } from 'redux-observable';
import { filter, map } from 'rxjs';
import { type Action } from '@reduxjs/toolkit';
import { fetchDemo } from '@/slices/demo';
import { startPendingCall, stopPendingCall } from '../actions';

const trimSuffix = (type: string) => type.replace(/\/(succeeded|failed)$/, '');

const GLOBAL_LOADER_ACTIONS = [fetchDemo] as const;

const startPendingCallEpic: Epic = (action$) =>
  action$.pipe(
    ofType(...GLOBAL_LOADER_ACTIONS),
    map(({ type }) => startPendingCall(type)),
  );

const stopPendingCallEpic: Epic = (action$) =>
  action$.pipe(
    filter(
      ({ type }: Action) =>
        type.includes('succeeded') || type.includes('failed'),
    ),
    map(({ type }) => stopPendingCall(trimSuffix(type))),
  );

export default combineEpics(startPendingCallEpic, stopPendingCallEpic);
